<template>
  <div class="dcFooter">
    
    <div class="wrapper">
      <div class="logo-box">
        <img
          class="dc-logo"
          src="../../assets/img/dcFooter/dc.png"
          alt=""
          srcset=""
        />
        <img
          class="vega-logo"
          src="../../assets/img/dcFooter/vega.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="line" v-if="!user_agent"></div>
      <!-- pc端布局 -->
      <div class="user">
        <div class="policy info">
          <span @click="showPrivacypolicy">{{
            $t("message.Privacypolicy")
          }}</span
          >&nbsp;&nbsp;
          <span @click="showAgreement">{{ $t("message.UserAgreement") }}</span>
        </div>
        <div class="copyright info">
          Copyright © 2020 Clicktouch Technology. All rights reserved.
        </div>
        <p class="info">
          Bản quyền thuộc về Clicktouch, Soha Game phát hành độc quyền tại Việt
          Nam
        </p>
        <p class="info">
          Công ty TNHH Soha - Tầng 19, Hapulico Center Building, số 1 Nguyễn Huy
          Tưởng, Hà Nội.
        </p>
        <p class="info">
          Giấy phép cung cấp dịch vụ trò chơi điện tử G1 trên mạng theo giấy phép số 55/GP-BTTTT cấp ngày 25/01/2018
        </p>
        <p class="info">
          Quyết định phê duyệt nội dung kịch bản trò chơi điện tử G1 trên mạng số: 1204/QĐ-BTTTT do Bộ Thông tin và Truyền thông cấp ngày 11/08/2021
        </p>
        <p class="info">
          <a target="_blank" href="https://giayphep.abei.gov.vn/g1/130777" >https://giayphep.abei.gov.vn/g1/130777</a>
        </p>
        <p class="info text">
          Báo lỗi và góp ý tại fanpage của game và mail hỗ trợ : hotro@sohagame.vn . Thời gian phục vụ từ 9h00 - 18h00
        </p>
      </div>
    </div>
    <div class="age-limit"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "dcFooter",
  components: {},
  data() {
    return {
      privacy: "",
      userTreaty: "",
    };
  },
  computed: {
    ...mapGetters(["user_agent"]),
  },
  methods: {
    async getDialogContent() {
      let param1 = {
        type: "userTreaty",
      };
      const res1 = await this.APIS.getDialogContent(param1);
      this.userTreaty = res1.data;
      let param2 = {
        type: "privacy",
      };
      const res2 = await this.APIS.getDialogContent(param2);
      this.privacy = res2.data;
    },
    showPrivacypolicy() {
      window.open("https://sohagame.vn/chinh-sach-bao-mat");
      // this.$store.dispatch("set_popup_datas", {
      //   type: "h_policy",
      //   msg: this.privacy,
      // });
    },
    showAgreement() {
      window.open("https://sohagame.vn/dieu-khoan");
      // this.$store.dispatch("set_popup_datas", {
      //   type: "h_agreement",
      //   msg: this.userTreaty,
      //   // msg:"Lời mở đầu<br/><p>Chào mừng bạn đã sử dụng trò chơi trực tuyến do “Clicktouch Technology International Company Limited” (sau đây gọi tắt là ““Clicktouch Technology””) cung cấp!</p><p>Chào mừng bạn đã sử dụng trò chơi trực tuyến do “Clicktouch Technology International Company Limited” (sau đây gọi tắt là ““Clicktouch Technology””) cung cấp!</p><p>Chào mừng bạn đã sử dụng trò chơi trực tuyến do “Clicktouch Technology International Company Limited” (sau đây gọi tắt là ““Clicktouch Technology””) cung cấp!</p><p>Chào mừng bạn đã sử dụng trò chơi trực tuyến do “Clicktouch Technology International Company Limited” (sau đây gọi tắt là ““Clicktouch Technology””) cung cấp!</p>"
      // });
    },
  },
  mounted() {
    this.getDialogContent();
  },
};
</script>
<style lang="less" scoped>
.dcFooter {
  width: 100vw;
  // height: 237px;
  background: url("../../assets/img/dcFooter/footer-bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .age-limit {
    bottom: 100px;
    right: 320px;
    position: static;
    width: 46px;
    height: 102px;
    background: url("https://sohagame.vn/img/18f.webp") center no-repeat;
    background-size: 100%;
  }
}
.wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  .logo-box {
    width: 360px;
    height: 132px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .vega-logo {
      width: 137px;
      height: 132px;
    }
    .dc-logo {
      width: 158px;
      height: 132px;
    }
  }
  .line {
    width: 2px;
    height: 132px;
    background: #d4d4d4;
    margin: 20px 30px;
  }
  .user {
    cursor: pointer;
    flex: 1;
    color: #a74f4c;
    // height: 73px;
    box-sizing: border-box;
    padding: 15px 0;
    .info {
      line-height: 26px;
      margin: 8px;
      a{
        color: #a74f4c;
        text-decoration: none;
      }
    }
    .text {
      color: #f19393;
    }
  }
}
@media screen and (max-width: 640px) {
  .dcFooter {
    width: 100vw;
    height: 3.9rem;
    background: url("../../assets/img/dcFooter/footer-bg.png") no-repeat;
    background-size: 100% 100%;
    .age-limit {
      right: 20px;
      position: absolute;
    }
  }
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    padding-top: 0.4rem;
    box-sizing: border-box;
    // margin-top: 0.4rem;
    // overflow: hidden;
    .logo-box {
      width: 3.4rem;
      height: 1.32rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .vega-logo {
        width: 1.37rem;
        height: 1.32rem;
      }
      .dc-logo {
        width: 1.58rem;
        height: 1.32rem;
      }
    }
    .user {
      cursor: pointer;
      flex: 1;
      color: #a74f4c;
      height: 0.73rem;
      box-sizing: border-box;
      padding: 0.15rem 0.2rem;
      font-size: 0.14rem;
      text-align: left;
      .info {
        line-height: 0.2rem;
        margin: 0rem;

      }
    }
  }
}
</style>
